module.exports = __webpack_public_path__ + "static/media/178.26deb560.mp3";